module.exports = __webpack_public_path__ + "img/logo_menubar_bw.73631cf1.svg";